/* Same Skies - cart friction fixes, 2026-10-19.
   Clarity 19 Oct: a UK builder shopper hit "✓ Added", saw no basket, tapped x on every tile
   and left; an AU shopper stalled on the wine choice in the drawer and never reached checkout.
   1. Internal traffic: ?ss_internal=1 declines analytics + marketing consent on this browser,
      so our own tests stop reaching Meta, TikTok, GA4 and Clarity. ?ss_internal=0 clears the flag.
   2. Clarity custom events: every ss_* dataLayer event is mirrored to clarity('event').
   3. Gift builder: once the box is in the cart the review step locks (no tile x), says so,
      and the button opens the cart. If the drawer fails to open, fall back to /cart.
   4. Cart drawer: the wine rail starts as one tappable line; the choice opens on tap.
   5. Builder speed: warm the stock-check worker while the review step is open.
   6. Phone builder sized to the measured visible height, so step 1 never scrolls. */
(function () {
  'use strict';
  var script = document.currentScript;
  var market = (script && script.getAttribute('data-market')) || '';
  var rootUrl = (script && script.getAttribute('data-root')) || '';

  /* ---------- 1. internal traffic ---------- */
  var COOKIE = 'ss_internal';
  function hasCookie() { return document.cookie.split('; ').indexOf(COOKIE + '=1') !== -1; }
  function withPrivacy(fn) {
    var tries = 0;
    (function wait() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.setTrackingConsent === 'function') return fn(cp);
      if (tries === 0 && window.Shopify && window.Shopify.loadFeatures) {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
      }
      if (++tries < 100) setTimeout(wait, 100);
    })();
  }
  var flag = new URLSearchParams(location.search).get('ss_internal');
  if (flag === '1') document.cookie = COOKIE + '=1; path=/; max-age=31536000; SameSite=Lax';
  if (flag === '0') document.cookie = COOKIE + '=; path=/; max-age=0; SameSite=Lax';
  var internal = flag === '1' || (flag !== '0' && hasCookie());
  if (internal) {
    withPrivacy(function (cp) {
      var marketingOn = typeof cp.marketingAllowed === 'function' && cp.marketingAllowed();
      var analyticsOn = typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed();
      if (marketingOn || analyticsOn || flag === '1') {
        cp.setTrackingConsent({ analytics: false, marketing: false, preferences: true, sale_of_data: false }, function () {});
      }
    });
    document.documentElement.setAttribute('data-ss-internal', '');
  }

  /* ---------- 2. Clarity events ---------- */
  window.dataLayer = window.dataLayer || [];
  function mirror(entry) {
    try {
      if (entry && typeof entry.event === 'string' && entry.event.indexOf('ss_') === 0 && typeof window.clarity === 'function') {
        window.clarity('event', entry.event);
      }
    } catch (e) {}
  }
  if (!window.dataLayer.__ssClarity) {
    var push = window.dataLayer.push;
    window.dataLayer.push = function () {
      for (var i = 0; i < arguments.length; i++) mirror(arguments[i]);
      return push.apply(this, arguments);
    };
    window.dataLayer.__ssClarity = true;
  }
  function track(name) {
    try { window.dataLayer.push({ event: name, ss_market: market }); } catch (e) {}
  }

  /* ---------- helpers ---------- */
  function drawerRoot() { return document.querySelector('.ct-root'); }
  function drawerVisible() {
    var root = drawerRoot();
    if (!root || root.getAttribute('data-open') !== 'true') return false;
    var panel = root.querySelector('aside.ct') || root;
    var r = panel.getBoundingClientRect();
    return r.width > 0 && r.right > 0 && r.left < window.innerWidth;
  }
  // Last resort when the drawer will not show: checkout. /cart is no good here, the theme's cart
  // template bounces to the homepage and reopens the same drawer. The card can be written after checkout.
  // A background tab pauses the drawer's slide-in, so only judge it while the page is visible.
  function whenVisible(fn) {
    if (document.visibilityState === 'visible') return fn();
    document.addEventListener('visibilitychange', function once() {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', once);
      setTimeout(fn, 900);
    });
  }
  function openCart() {
    if (typeof window.openCartDrawerV3 === 'function') {
      try { window.openCartDrawerV3({}); } catch (e) {}
    }
    setTimeout(function () {
      whenVisible(function () {
        if (drawerVisible()) return;
        track('ss_cart_fallback_checkout');
        location.href = rootUrl.replace(/\/$/, '') + '/checkout';
      });
    }, 900);
  }

  /* ---------- 3. gift builder: lock the review step after the box is added ---------- */
  // Only the review step is locked. Back to step 1 keeps the builder's own Continue button working.
  // Short on phones: the dock's left column wraps to three lines next to the long label.
  // No arrow in the text: the button draws its own with ::after.
  function btnLabel() { return window.matchMedia('(max-width: 480px)').matches ? 'View cart' : 'View cart & checkout'; }
  function labelOk(b) {
    var want = btnLabel().replace('cart', '(cart|basket)').replace('&', '&');
    return new RegExp('^\\s*' + want + '\\s*$', 'i').test(b.textContent);
  }
  function isLocked() { return document.documentElement.classList.contains('ss-gb-added'); }
  function onReview() {
    var step = document.getElementById('gb-step-4');
    return !!(step && step.classList.contains('active'));
  }
  function builderButtons() {
    return Array.prototype.slice.call(document.querySelectorAll('.gb-bar-continue'));
  }
  function lockBuilder() {
    var wrap = document.getElementById('gb-step-4');
    if (!wrap) return;
    document.documentElement.classList.add('ss-gb-added');
    var title = wrap.querySelector('.gb-card-title');
    if (title && !title.hasAttribute('data-ss-orig')) {
      title.setAttribute('data-ss-orig', title.innerHTML);
      title.innerHTML = 'In your cart - <em>looks perfect</em>';
    }
    if (!wrap.querySelector('.ss-gb-added-note')) {
      var note = document.createElement('p');
      note.className = 'ss-gb-added-note';
      note.setAttribute('role', 'status');
      note.innerHTML = '<span aria-hidden="true">&#10003;</span> Your box is in the cart. Next, write the card and check out.';
      var body = wrap.querySelector('.gb-card-body');
      if (body) body.insertBefore(note, body.firstChild);
    }
    relabel();
  }
  // The dock's "Full · add 2 more in Midnight" upsell would start a second box. Drop the link and its dot.
  function dropUpsell() {
    document.querySelectorAll('a[onclick*="gbUpgradeTier"]').forEach(function (a) {
      var prev = a.previousSibling;
      if (prev && prev.nodeType === 3) prev.nodeValue = prev.nodeValue.replace(/\s*·\s*$/, '');
      a.remove();
    });
  }
  function relabel() {
    if (!isLocked()) return;
    dropUpsell();
    if (!onReview()) return;
    builderButtons().forEach(function (b) {
      if (!labelOk(b)) b.textContent = btnLabel();
      b.disabled = false;
      b.removeAttribute('aria-disabled');
      b.style.background = '';
    });
  }
  // The builder rewrites its own button text; keep ours while the locked review step is showing.
  new MutationObserver(relabel).observe(document.documentElement, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });

  // Capture phase: runs before the button's own onclick, which would try to add a second box.
  document.addEventListener('click', function (ev) {
    if (!isLocked() || !onReview()) return;
    var b = ev.target.closest && ev.target.closest('.gb-bar-continue');
    if (!b) {
      // The "add 2 more in Midnight" upsell would start a second box; the cart holds one.
      if (ev.target.closest && ev.target.closest('a[onclick*="gbUpgradeTier"]')) { ev.preventDefault(); ev.stopPropagation(); }
      return;
    }
    ev.preventDefault();
    ev.stopPropagation();
    track('ss_builder_view_cart');
    openCart();
  }, true);

  document.addEventListener('cart:update', function (ev) {
    var src = ev && ev.detail && ev.detail.data && ev.detail.data.source;
    if (src !== 'gift-builder') return;
    track('ss_builder_added');
    lockBuilder();
    // The builder already asked the drawer to open. If it isn't on screen, ask again, then go to /cart.
    setTimeout(function () {
      whenVisible(function () {
        if (drawerVisible()) return;
        track('ss_builder_drawer_missed');
        openCart();
      });
    }, 1200);
  });

  // If the box leaves the cart (even with wine or a print still in it), unlock so they can add it again.
  function unlockBuilder() {
    document.documentElement.classList.remove('ss-gb-added');
    var wrap = document.getElementById('gb-step-4');
    if (!wrap) return;
    var title = wrap.querySelector('.gb-card-title[data-ss-orig]');
    if (title) { title.innerHTML = title.getAttribute('data-ss-orig'); title.removeAttribute('data-ss-orig'); }
    var note = wrap.querySelector('.ss-gb-added-note');
    if (note) note.remove();
    if (onReview()) builderButtons().forEach(function (b) { b.textContent = 'Add to cart'; });
  }
  // Same test as gbCartHasGift in sections/gift-builder.liquid.
  function cartHasGift(cart) {
    return (cart.items || []).some(function (item) {
      return !!(item.properties && item.properties._gift_box) ||
        String(item.product_type || '').toLowerCase() === 'gift box' ||
        /^gift-box-/.test(item.handle || '') ||
        ['dusk-box', 'twilight-box', 'midnight-box', 'little-comforts-box', 'horizon-box'].indexOf(item.handle) !== -1;
    });
  }
  document.addEventListener('cart:update', function (ev) {
    var d = ev && ev.detail && ev.detail.data;
    if (!d || d.source === 'gift-builder' || !isLocked()) return;
    if (d.itemCount === 0) { unlockBuilder(); return; }
    if (typeof d.itemCount !== 'number') return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { if (isLocked() && !cartHasGift(cart)) unlockBuilder(); })
      .catch(function () {});
  });

  // The stock check before add took 1.8-2.7s cold (19 Oct). Open the connection and wake the
  // worker while the shopper is still reading the review step, so the real check is warm.
  var STOCK = 'https://same-skies-byo-inventory.same-skies.workers.dev';
  var lastWarm = 0;
  function warmStock() {
    if (Date.now() - lastWarm < 45000) return;
    lastWarm = Date.now();
    // A real component id: an empty list returns before the worker's token mint and Shopify read.
    var card = document.querySelector('.gb-product-card[data-variant]:not([data-id="art_print"])');
    var id = card && card.getAttribute('data-variant');
    if (!id) return;
    try { fetch(STOCK + '/availability?ids=' + encodeURIComponent(id), { mode: 'no-cors', cache: 'no-store' }).catch(function () {}); } catch (e) {}
  }
  function watchBuilder() {
    var step = document.getElementById('gb-step-4');
    if (!step) return;
    var link = document.createElement('link');
    link.rel = 'preconnect';
    link.href = STOCK;
    link.crossOrigin = 'anonymous';
    document.head.appendChild(link);
    if (step.classList.contains('active')) warmStock();
    new MutationObserver(function () {
      if (step.classList.contains('active')) warmStock();
    }).observe(step, { attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchBuilder); else watchBuilder();

  /* ---------- 6. builder fits the visible screen ---------- */
  // The phone builder pins itself at 100dvh. Some iPhone browsers report that taller than what is
  // on screen, so the step overflowed and scrolled. Use the measured visible height, less the staff
  // preview bar when it is showing (customers never see that bar).
  function syncAppHeight() {
    var html = document.documentElement;
    if (!html.classList.contains('gb-mobile-app-lock')) { html.style.removeProperty('--ss-app-h'); return; }
    var h = window.innerHeight;
    var bar = document.getElementById('PBarNextFrameWrapper');
    if (bar) {
      var r = bar.getBoundingClientRect();
      if (r.height > 0 && r.top < h && getComputedStyle(bar).display !== 'none') h = Math.min(h, Math.round(r.top));
    }
    html.style.setProperty('--ss-app-h', h + 'px');
  }
  syncAppHeight();
  window.addEventListener('resize', syncAppHeight);
  window.addEventListener('orientationchange', function () { setTimeout(syncAppHeight, 300); });
  if (window.visualViewport) window.visualViewport.addEventListener('resize', syncAppHeight);
  window.addEventListener('load', function () { syncAppHeight(); setTimeout(syncAppHeight, 1500); });
  new MutationObserver(syncAppHeight).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

  /* ---------- 4. cart drawer: wine as one line until tapped ---------- */
  function wineRail() {
    return document.querySelector('.ct-root .ct-addon[data-ct-addon-handle="piccolo-wine"]');
  }
  function priceText(rail) {
    var label = rail.querySelector('[data-ct-addon-label]');
    var m = label && label.textContent.match(/(?:A\$|\$|£)\s?[\d.,]+(?:\s*\(?≈\s*£\s?[\d.,]+\)?)?/);
    if (m) return m[0];
    var add = rail.querySelector('[data-ct-addon-add]');
    return (add && add.getAttribute('data-price')) || '';
  }
  function setupWine() {
    var rail = wineRail();
    if (!rail) return;
    if (!rail.__ssEase) {
      rail.__ssEase = true;
      var t = document.createElement('button');
      t.type = 'button';
      t.className = 'ss-wine-toggle';
      t.setAttribute('aria-expanded', 'false');
      t.innerHTML = '<span class="ss-wine-toggle-txt"><span class="ss-wine-toggle-t">Add a little <em>wine</em>?</span>' +
        '<span class="ss-wine-toggle-d">Poco Vino Piccolo &middot; 187ml &middot; optional</span></span>' +
        '<span class="ss-wine-toggle-p" data-ss-wine-price></span><span class="ss-wine-toggle-c" aria-hidden="true"></span>';
      rail.insertBefore(t, rail.firstChild);
      t.addEventListener('click', function () {
        var open = rail.classList.toggle('ss-wine-open');
        t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) track('ss_wine_open');
      });
    }
    var p = rail.querySelector('[data-ss-wine-price]');
    if (p) {
      var txt = priceText(rail);
      if (txt && p.textContent !== '+' + txt) p.textContent = '+' + txt;
    }
  }
  function collapseWine() {
    var rail = wineRail();
    if (!rail) return;
    rail.classList.remove('ss-wine-open');
    var t = rail.querySelector('.ss-wine-toggle');
    if (t) t.setAttribute('aria-expanded', 'false');
  }
  var lastOpen = false;
  function watchDrawer() {
    var root = drawerRoot();
    if (!root) return;
    setupWine();
    new MutationObserver(function () {
      var isOpen = root.getAttribute('data-open') === 'true';
      if (isOpen && !lastOpen) collapseWine();
      lastOpen = isOpen;
      setupWine();
    }).observe(root, { attributes: true, attributeFilter: ['data-open'], childList: true, subtree: true, characterData: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchDrawer); else watchDrawer();
})();
